import Games from './games'
import type { FavoritesGamesType } from './types'

function GamesRoot(props: FavoritesGamesType) {
  return (
    <>
      <Games {...props} />
    </>
  )
}

export default GamesRoot
